







import { Component, Mixins } from 'vue-property-decorator'
import AgentInfo from './AgentInfo.vue'
import Unsubscribe from './Unsubscribe.vue'
import GlobalMixin from '@/mixins/GlobalMixin'

@Component({
  components: {
    AgentInfo,
    Unsubscribe
  }
})
export default class AgentCard extends Mixins(GlobalMixin) {}
